import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getSubscription } from '../services/paymentService';

const TIER_NAMES = { 1: 'Basic', 2: 'Advanced', 3: 'Enterprise' };

const PaymentSuccess = () => {
	const [searchParams] = useSearchParams();
	const sessionId = searchParams.get('session_id');
	const { userProfile, checkAuth } = useAuth();
	const [subscription, setSubscription] = useState(null);
	const [loading, setLoading] = useState(true);

	// Refresh auth so the latest userProfile is available, then fetch the
	// subscription. A short delay lets the Stripe webhook reach the backend first.
	useEffect(() => {
		const timer = setTimeout(async () => {
			await checkAuth();
			setLoading(false);
		}, 2500);
		return () => clearTimeout(timer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (!userProfile?.userId) return;
		getSubscription(userProfile.userId)
			.then(setSubscription)
			.catch(() => {});
	}, [userProfile?.userId]);

	return (
		<div className='min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4'>
			<div className='max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-10 text-center'>
				<div className='text-6xl mb-6'>✅</div>
				<h1 className='text-3xl font-bold text-gray-900 dark:text-white mb-3'>
					Payment Successful!
				</h1>
				<p className='text-gray-600 dark:text-gray-300 mb-2'>
					Thank you for subscribing to ValuePay XR.
				</p>

				{loading ? (
					<p className='text-sm text-gray-400 mt-2 mb-6'>Confirming your plan...</p>
				) : subscription ? (
					<p className='mt-2 mb-6 font-semibold text-teal-600 dark:text-teal-400'>
						{TIER_NAMES[subscription.tier] || `Tier ${subscription.tier}`} Plan activated.
					</p>
				) : (
					<p className='text-sm text-gray-400 mt-2 mb-6'>
						Your plan will be reflected shortly.
					</p>
				)}

				{sessionId && (
					<p className='text-xs text-gray-400 mb-8 break-all'>
						Reference: {sessionId}
					</p>
				)}

				<Link
					to='/'
					className='inline-block bg-teal-500 hover:bg-teal-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-200'
				>
					Go to Homepage
				</Link>
			</div>
		</div>
	);
};

export default PaymentSuccess;